/**
 * Agent-related types for the Assistant package
 */

/**
 * Context requirements for agent filtering
 * Determines when an agent should be available based on page context
 *
 * @property type - "global" agents are always available, "context_specific" require context fields
 * @property required - All of these context fields must be present
 * @property required_any - At least one of these context fields must be present
 * @property optional - These fields are used if present but not required
 */
export type ContextRequirements = {
  type: 'global' | 'context_specific';
  required: string[];
  required_any?: string[];
  optional?: string[];
};

export interface AgentDefinition {
  uuid: string;
  kit_name: string;
  title: string;
  description: string;
  status: string;
  context_requirements: ContextRequirements;
  plan_mode_available: boolean;
  created_at: string;
  updated_at: string;
  tags: AgentTags[];
}

export const TAGS = {
  ICM: 'ICM',
  DATA_CONNECTORS: 'DATA_CONNECTORS',
  SP: 'SP',
  CATALYST: 'CATALYST',
  EPM: 'EPM',
  PAYOPS: 'PAYOPS',
} as const;

export type AgentTags = (typeof TAGS)[keyof typeof TAGS];
